import React from "react";
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";
import { Box, TextField } from "@mui/material";

export function ColorTab({color, setColor}: {color: string, setColor: Function}) {  
    const handleChange = (newColor: string) => {
      setColor(newColor);
    };
  
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <TextField sx={{ marginBottom: "10px" }} label="Cor Atual" value={color} variant="outlined" size="small"/>
        <HexAlphaColorPicker color={color} onChange={handleChange} />
        <HexColorInput onChange={handleChange} style={{ marginTop: "10px" }} />
      </Box>
    );
}
